import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import styles from './LoadIndicator.module.css';
import { useTranslation } from 'react-i18next';
const LoadIndicator = ({ color, height }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.loadContainer} style={{ minHeight: height }}>
      <Typography
        style={{
          color: color,
          fontFamily: `var(--font-main), Sans-serif, Arial`
        }}>
        {t('login.moment')}
      </Typography>
      <CircularProgress size={70} className={styles.spinner} style={{ color: color }} />
    </div>
  );
};

export default LoadIndicator;
